module.exports = __webpack_public_path__ + "img/convergenze_logo3.2c153b1a.png";